import { isSmartContractWalletApp } from '@onramp/utils/isSmartContractWalletApp';
import { useInitParams } from '@onramp/v2/client/contexts/initParams/InitParamsContext';

export function useIsSmartContractWallet() {
  const {
    internalInitParams: {
      clientAppDetails: { appId },
    },
  } = useInitParams();

  return isSmartContractWalletApp(appId);
}
